import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';
import { map } from 'rxjs/operators';
import { DeleteEntityServiceInterface } from '../interface/delete-entity-service-interface';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import { ListUserColumnsResponse } from 'it/primatoo/openapi/api/org/schemas/common/ListUserColumnsResponse';
import { UpsertUserColumnRequest } from 'it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest';
import { ListIncidentReportResponse } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/ListIncidentReportResponse';
import { IncidentReport } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/listindicentreportresponse/IncidentReport';
import { CreateIncidentReportRequest } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/CreateIncidentReportRequest';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root',
})
export class DataBreachProcessIncidentReportsService
  implements DeleteEntityServiceInterface
{
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    this.endpoint =
      this.config.endPoint +
      '/api/org/v2/data-breach-processes/incident-reports/';
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns/`;
    return this.httpClient
      .get<ListUserColumnsResponse>(url)
      .pipe(map((p) => p.columns));
  }

  public findById(id: number): Observable<IncidentReport> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<IncidentReport>(url);
  }

  public cancelDeleting(id: number): Observable<void> {
    const url = this.endpoint + `${id}/cancel-deleting`;
    return this.httpClient.post<void>(url, {});
  }

  public delete(id: number): Observable<void> {
    const url = this.endpoint + `${id}/`;
    return this.httpClient.delete<void>(url);
  }

  public findAllIncidentReports(): Observable<ListIncidentReportResponse> {
    const url = this.endpoint;
    return this.httpClient.get<ListIncidentReportResponse>(url);
  }

  public updateUserColumns(request: UpsertUserColumnRequest): Observable<void> {
    const url = this.endpoint + 'user-columns';
    return this.httpClient.post<void>(url, request);
  }

  public create(
    requestBody: CreateIncidentReportRequest
  ): Observable<CreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }

  public deleteMultiple(ids: number[]): Observable<{ failed: number[] }> {
    return EMPTY;
  }

  getDocDependencies(id: number): Observable<any> {
    return EMPTY;
  }
}
